// extracted by mini-css-extract-plugin
export default {"root":"dottedButton_root__opIQG"};